import classNames from "../../functions/classNames";

const STATUS_STYLES = {
  mapped: "bg-green-100 text-green-800 ring-green-600/20",
  partial: "bg-amber-100 text-amber-800 ring-amber-600/20",
  unmapped: "bg-gray-100 text-gray-700 ring-gray-500/20",
  skipped: "bg-slate-100 text-slate-600 ring-slate-500/20",
};

export default function WordChip({ word, isSelected, onClick }) {
  const status = word.mapping_status;
  const icon =
    status === "mapped" ? "✓" : status === "skipped" ? "—" : status === "partial" ? "◐" : "○";

  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        "inline-flex items-center gap-1 rounded-md px-2 py-1 text-sm font-medium ring-1 ring-inset transition",
        isSelected
          ? "ring-2 ring-ramsalab-teal-blue bg-ramsalab-teal-blue/10"
          : STATUS_STYLES[status] || STATUS_STYLES.unmapped,
        "hover:opacity-90"
      )}
    >
      <span className="text-xs opacity-70">{icon}</span>
      <span dir="auto">{word.surface}</span>
    </button>
  );
}
